<template>
  <div class="container py-5" style="min-height:70vh">
    <h2>Cjenik usluga - CSV</h2>
    <div class="container table-responsive py-3">
        <table class="table">
            <tr>
                <th>Datum</th>
                <th>Datoteka</th>
            </tr>
            <tr>
                <td>01.10.2026 07:59</td>
                <td>
                    <a href="/files/prices/IGPROG_Ludvetov_Breg_5_Rijeka_01_01102026_0759.csv" download>
                        IGPROG_Ludvetov_Breg_5_Rijeka_01_01102026_0759.csv
                    </a>
                </td>
            </tr>
        </table>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: "%s | Cjenik usluga",
    meta: [
      {
        name: "description",
        content:
          "IG PROG, OBRT ZA RAČUNALNO PROGRAMIRANJE  - Cjenik usluga",
      },
    ],
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/prices-csv.vue